function RegistrationFieldGroup() {
    var self = this;

    self.name = null;
    self.description = null;
    self.fields = ko.observable([]);
    self.fieldsWithValuesExcludingBooleans = ko.computed(function () {
        return ko.utils.arrayFilter(self.fields(), function (field) {
            return field.fieldTypeName !== 'Boolean'  && field.fieldValue() !== null && field.fieldValue() !== '';
        });
    });
    self.fieldsWithoutValues = ko.computed(function () {
        return ko.utils.arrayFilter(self.fields(), function (field) {
            return field.fieldValue() === null ||  field.fieldValue() === '';
        });
    });
    self.fieldsWithoutValuesAndBooleans = ko.computed(function () {
        return ko.utils.arrayFilter(self.fields(), function (field) {
            return field.fieldTypeName === 'Boolean' || (field.fieldValue() === null || field.fieldValue() === '');
        });
    });
}

function RegistrationField(data, registrationFieldTypes, registrationTypes, registrationFieldListItems) {
    var self = this;

    self.fieldInfo = data;

    self.maxLength = self.fieldInfo.MaxLength ? self.fieldInfo.MaxLength.toString() : '40';
    self.labelText = self.fieldInfo.Text;
    self.placeholderText = 'Enter ' + self.fieldInfo.Text;
    self.fieldTypeName = registrationFieldTypes[self.fieldInfo.FieldType.toString()];
    self.registrationTypeName = registrationTypes[self.fieldInfo.RegistrationType.toString()];
    self.isEditing = ko.observable(false);
    self.validationErrors = ko.observableArray([]);
    self.hasValidationErrors = ko.computed(function () {
        return self.validationErrors() && self.validationErrors().length > 0;
    });

    self.listItems = [];

    if (self.fieldTypeName === 'List') {
        self.listItems = $.grep(registrationFieldListItems, function (listItem) {
            return listItem.ParentRegistrationField.Id === self.fieldInfo.Id;
        });
    }

    self.fieldValue = ko.observable(self.fieldTypeName === 'Boolean' ? self.fieldInfo.DefaultValueAsBool : self.fieldInfo.DefaultValue);
    self.fieldTempValue = ko.observable(null);
    self.fieldTempValue.subscribe(function(newValue) {
        self.isValid();
    });

    self.fieldValueForDisplay = ko.computed(function () {
        if (self.fieldValue() === null)
            return self.fieldValue();

        if (self.fieldTypeName === 'Text' && self.registrationTypeName === 'DateOfBirth') {
            var isoDate = new Date(self.fieldValue()).toISOString();
            var dateParts = isoDate.split(/[-T]/);

            return $.datepicker.formatDate('m/d/y', new Date(dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2]));
        }

        if (self.fieldTypeName === 'List') {
            var matches = $.grep(self.listItems, function(item) {
                return item.DefaultValue === self.fieldValue();
            });

            return matches.length === 0 ? self.fieldValue() : matches[0].Text;
        }

        return self.fieldValue();
    });

    self.isValid = function () {
        self.validationErrors([]);

        if (self.fieldTypeName === 'List') {
            return true;
        }

        if ((self.fieldTempValue() === null || self.fieldTempValue() === '') && self.fieldInfo.IsRequired) {
            self.validationErrors.push(Alkami.Localization.SiteText['Registration.Validation.IsRequired'].replace('{0}', self.labelText));
        }

        if (self.fieldTempValue() !== null && self.fieldTempValue() !== '') {
            switch (self.registrationTypeName.toLowerCase()) {
                case 'dateofbirth':
                    if (isNaN(Date.parse(self.fieldTempValue()))) {
                        self.validationErrors.push(Alkami.Localization.SiteText['Registration.Validation.EnterValid'].replace('{0}', self.labelText));
                    }
                    break;
                case 'zipcode':
                    if (!self.fieldTempValue().match(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnpstvxy]{1}\d{1}[A-Za-z]{1} ?\d{1}[A-Za-z]{1}\d{1})$/)) {
                        self.validationErrors.push(Alkami.Localization.SiteText['Registration.Validation.EnterValid'].replace('{0}', self.labelText));
                    }
                    break;
                case 'ein':
                case 'taxid':
                    var numDigits = $('#num_digits').val();
                    var minNumDigits = $('#min_num_digits').val();
                    //var expression = "^\\d{" + numDigits + "}$"; 
                    //^[0-9]{4,9}$
                    var expression = '^[0-9]{' + minNumDigits + ',' + numDigits + '}$';
                    // This expression ensures the entry is a number with length between the minNumDigits and numDigits
                    if (!self.fieldTempValue().match(new RegExp(expression))) {
                        self.validationErrors.push(Alkami.Localization.SiteText['Registration.Validation.EnterValid'].replace('{0}', self.labelText));
                    }
                    break;
                case 'homephone':
                    var phoneNumber = self.fieldTempValue().replace(/\s+/g, '');
                    if (phoneNumber.length <= 9 && !phoneNumber.match(/^([\(]{1}[0-9]{3}[\)]{1}[\.| |\-]{0,1}|^[0-9]{3}[\.|\-| ]?)?[0-9]{3}(\.|\-| )?[0-9]{4}$/)) {
                        self.validationErrors.push(Alkami.Localization.SiteText['RegistrationValidationEnterValidNumber']);
                    }
                    break;
            };
        }

        var $panel = $('#confirm_identity_edit_field_panel');
        
        if (self.validationErrors().length === 0) {
            $panel.find('.ani-input-error-block').height(0);
            $panel.find('.input-container').removeClass('ani-input-error');
            registrationArea.updateTitleBar(registrationArea.confirmIdentityEditFieldWithEnabledDoneNavBar);
        } else {
            $panel.find('.ani-input-error-block').height($panel.find('.error-text').outerHeight(true));
            $panel.find('.input-container').addClass('ani-input-error');
            registrationArea.updateTitleBar(registrationArea.confirmIdentityEditFieldWithDisabledDoneNavBar);
        }
        
        return self.validationErrors().length === 0;
    };
}

